export const listWebFormByRequester = /* GraphQL */ `
  query listWebFormByRequester(
    $input: ListWebFormByRequesterInput!
    $nextToken: String
  ) {
    listWebFormByRequester(input: $input, nextToken: $nextToken) {
      scannedCount
      items {
        data
      }
      nextToken
    }
  }
`;
